/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text } from 'bold-ui'

export function AtividadeColetivaGrupoSelectFieldVazio() {
  return (
    <div css={createStyles.emptyItem}>
      <HFlow alignItems='center' hSpacing={0.2}>
        <Text fontStyle='italic'>Nenhum resultado encontrado</Text>
      </HFlow>
    </div>
  )
}

const createStyles = {
  emptyItem: css`
    padding: 0.5rem 0.5rem;
  `,
}
